import { MaskedIcon } from '@/components/MaskedIcon/MaskedIcon';
import { Action } from '@/pages/home/components';
import theme from '@/theme';
import styled from '@emotion/styled';

const Label = styled.span`
    display: flex;
    align-items: center;
    gap: 8px;
    color: ${({ theme }) => theme.colors.secondary[900]};
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    white-space: nowrap;
`;

const Container = styled.div`
    display: flex;
    align-items: center;
    gap: 9px;
    padding: 16px 14px;
    border-radius: 12px;
    border: 1px solid ${theme.colors.black[300]};
    background-color: white;
    cursor: pointer;
    height: 90px;
    width: 288px;
    min-width: 288px;

    transition: all 0.2s ease-in-out;

    :hover {
        border: 1px solid ${theme.colors.primary[900]};

        & ${Label} {
            color: ${theme.colors.primary[900]};
        }
    }
`;

const NewBadge = styled.div`
    font-size: 12px;
    color: ${({ theme }) => theme.colors.primary.main};
    background-color: ${({ theme }) => theme.colors.primary.bgLight};
    border-radius: 555px;
    font-weight: 700;
    text-transform: capitalize;
    padding: 2px 6px;
`;

const IconColorCircle = styled.div<{ color: string }>`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 6px;
    background-color: ${({ color }) => color};
    border-radius: 100px;
    height: fit-content;

    img {
        width: 22px;
        height: 22px;
    }
`;

const IconWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 6px;
    height: fit-content;
`;

const TextContainer = styled.div`
    display: flex;
    flex-direction: column;
    max-width: 250px;
`;

const Description = styled.span`
    color: ${({ theme }) => theme.colors.secondary[900]};
    font-size: 14px;
    font-weight: 500;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    @supports (-webkit-line-clamp: 2) {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: initial;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
    }
`;

interface Props {
    action: Action;
}

export const ActionButton = ({ action }: Props) => {
    return (
        <Container id={action.id} onClick={action.onClick}>
            <IconWrapper>
                <IconColorCircle color={action.color}>
                    {action.iconAsImage ? <img src={action.icon} /> : <MaskedIcon src={action.icon} size="22px" color={action.iconColor} />}
                </IconColorCircle>
            </IconWrapper>

            <TextContainer>
                <Label>
                    {action.label}
                    {action.isNew && <NewBadge>Beta</NewBadge>}
                </Label>

                <Description>{action.description}</Description>
            </TextContainer>
        </Container>
    );
};
